/* eslint-disable import/no-duplicates */
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { Card, Col, Row } from 'react-bootstrap';

import { addWeeks, format, getYear, isSameWeek } from 'date-fns';

import { ptBR } from 'date-fns/locale';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';

import Loading from '../../components/Loading';

import { Container, AgendaDoDiaButton } from './styles';
import getResponseErrors from '../../utils/getResponseErrors';
import Button from '../../components/Button';

interface IAgendasDoDia {
  ConCodigo: number;
  ConNome: string;
  HorHoraIni: string;
  HorHoraFim: string;
  Agendamentos: number;
  Atendidos: number;
  Disponivel: boolean;
  ConTempoPadrao: number;
}
interface IAgendamentosPorDia {
  agendamentosSemana: {
    dia: string;
    diaFormatado?: string;
    dataFormatada?: string;
    qtd: number;
    agendas: IAgendasDoDia[];
  }[];
}
const AgendamentosSemanal: React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const [agendasPorDia, setAgendasPorDia] = useState<IAgendamentosPorDia>();

  const [dataSelecionada, setDataSelecionada] = useState(new Date());

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IAgendamentosPorDia>(
          `/agendamentos/agendaSemanal?data=${format(
            dataSelecionada,
            'yyyy-MM-dd',
          )}`,
        );

        const agendamentosFormatados = response.data.agendamentosSemana.map(
          ags => {
            const dm = ags.dia.split('/');

            const ano = getYear(new Date());

            const data = new Date(ano, Number(dm[1]) - 1, Number(dm[0]));
            const dataFormatada = format(data, 'yyyy-MM-dd');
            const diaFormatado = format(data, 'ccc dd/MM', {
              locale: ptBR,
            });
            return {
              ...ags,
              diaFormatado,
              dataFormatada,
            };
          },
        );
        setAgendasPorDia({ agendamentosSemana: agendamentosFormatados });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar agendas',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, [addToast, dataSelecionada]);

  const mesmaSemana = useMemo(() => {
    const semana = isSameWeek(new Date(), dataSelecionada);
    return semana;
  }, [dataSelecionada]);

  return (
    <Container>
      {loading && <Loading backgroundBlack={false} />}
      {agendasPorDia && agendasPorDia.agendamentosSemana.length > 0 ? (
        <>
          <h5 className="text-center my-4">
            Agendas Semanal
            <Link
              to="agendaenvioconfirmacao"
              className="float-right btn btn-sm btn-primary d-print-none"
            >
              Enviar confirmação
            </Link>
            <Link
              to="listaesperaatendimento"
              className="float-right btn btn-sm btn-primary mb-1 mr-3"
            >
              Lista Atendimento
            </Link>
            <Link
              to="agendas"
              className="float-right btn btn-sm btn-primary mx-3 d-print-none"
            >
              Agendas do Dia
            </Link>
            <Button
              type="button"
              className="float-right"
              variant="primary-outline"
              title="Proxima Semana"
              onClick={() => setDataSelecionada(state => addWeeks(state, 1))}
            >
              <span aria-hidden="true">&raquo;</span>
              <span className="sr-only">Next</span>
            </Button>
            <Button
              type="button"
              className={`float-right mx-3 ${mesmaSemana ? 'd-none' : ''}`}
              variant="primary-outline"
              title="Semana Anterior"
              onClick={() => setDataSelecionada(state => addWeeks(state, -1))}
            >
              <span aria-hidden="true">&laquo;</span>
              <span className="sr-only">Previous</span>
            </Button>
          </h5>

          <Row noGutters>
            {agendasPorDia.agendamentosSemana.map(ags => (
              <>
                <Col md={2} className="border border-dark">
                  <div className="d-flex flex-column align-items-center text-center py-2">
                    <h5>{ags.diaFormatado}</h5>
                    {ags.agendas.map(ag => (
                      <>
                        <AgendaDoDiaButton
                          key={`agen-${ag.ConCodigo}`}
                          type="button"
                          onClick={
                            () =>
                              history.push(
                                `/agenda/${ag.ConCodigo}?data=${ags.dataFormatada}&dias=1`,
                              )
                            // eslint-disable-next-line react/jsx-curly-newline
                          }
                          Disponivel={ag.Disponivel}
                        >
                          <div
                            className="p-1 w-100"
                            style={{ display: 'grid', minHeight: '115px' }}
                          >
                            <span>
                              <b>{ag.ConNome}</b>
                            </span>
                            <div>{`${ag.HorHoraIni} às ${ag.HorHoraFim}`}</div>
                            <div>{`${ag.ConTempoPadrao} em ${ag.ConTempoPadrao} min`}</div>
                            <span>
                              <b>{`${ag.Agendamentos} paciente(s)`}</b>
                            </span>
                          </div>
                        </AgendaDoDiaButton>
                      </>
                    ))}
                  </div>
                </Col>
              </>
            ))}
          </Row>

          {/* <AgendaDoDiaContainer>
            {agendasPorDia.map(agen => (
              <AgendaDoDiaButton
                key={`agen-${agen.ConCodigo}`}
                type="button"
                onClick={() => history.push(`/agenda/${agen.ConCodigo}`)}
                Disponivel={agen.Disponivel}
              >

                <h6>{agen.ConNome}</h6>
                {agen.Disponivel && (
                  <div>{`${agen.HorHoraIni} as ${agen.HorHoraFim}`}</div>
                )}
              </AgendaDoDiaButton>
            ))}
          </AgendaDoDiaContainer> */}
        </>
      ) : (
        <Card
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '250px' }}
        >
          <h5>Nenhuma agenda configurada para a data de hoje.</h5>
          <span>{JSON.stringify(agendasPorDia)}</span>
        </Card>
      )}
    </Container>
  );
};

export default AgendamentosSemanal;
